import Survey from '@/components/survey/Survey'
export default {
  name: 'show',
  components: {Survey},
  props: [],
  data () {
    return {
      survey: null
    }
  },
  computed: {
    // survey () {
    //   return this.$store.getters['Survey/getSurvey'].content ? this.$store.getters['Survey/getSurvey'].content : null
    // }
  },
  mounted () {
    this.$loading.start()
    this.$store.dispatch('Survey/showSurvey', {survey_id: this.$route.params.survey_id}).then(res => {
      this.survey = res
      this.$loading.complete()
    }).catch(errors => {
      this.$loading.fail()
    })
  },
  methods: {
    onComplete (data) {
      console.log(data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/survey/show/show.js